// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.map.to-json.js
 ** module id = 284
 ** module chunks = 0
 **/